module.exports = __webpack_public_path__ + "img/iron-widow.28643318.png";